import React, { useEffect, useState } from 'react';

import { OffersPageFilters } from 'prequalificationV2/components/Offers/OffersTableWrapper/offersTableWrapper.types';
import OffersTableMobile from 'prequalificationV2/components/Offers/OffersTableWrapper/OffersTableMobile/OffersTableMobile';
import OffersTable from 'prequalificationV2/components/Offers/OffersTableWrapper/OffersTable/OffersTable';
import { OffersTableColumnsTitle } from 'prequalificationV2/components/Offers/OffersTableWrapper/offersTableWrapper.enums';
import useMobileCheck from 'hooks/useMobileCheck';
import {
  MAX_MOBILE_WIDTH,
  OFFERS_SORTING_FIELD,
} from 'prequalificationV2/components/Offers/OffersTableWrapper/offersTableWrapper.constants';
import { OfferDto } from 'api/OffersApi';

export interface OffersTableWrapperProps {
  loanOffers: OfferDto[];
  onAcceptOffer: (loanOffer: OfferDto) => void;
  isDisabled: boolean;
}

const OffersTableWrapper = ({ loanOffers, onAcceptOffer, isDisabled }: OffersTableWrapperProps) => {
  const [sortedLoanOffers, setSortedLoanOffers] = useState<OfferDto[]>(loanOffers);
  const [filters, setFilters] = useState<OffersPageFilters>({
    sortField: OFFERS_SORTING_FIELD[OffersTableColumnsTitle.MonthlyPayments]!,
    isSortDesc: false,
  });
  const isMobile = useMobileCheck(MAX_MOBILE_WIDTH);

  useEffect(() => {
    const sortedOffers = [...loanOffers].sort((firstOffer, secondOffer) => {
      if (filters.isSortDesc) {
        return Number(secondOffer[filters.sortField]) - Number(firstOffer[filters.sortField]);
      }

      return Number(firstOffer[filters.sortField]) - Number(secondOffer[filters.sortField]);
    });

    setSortedLoanOffers(sortedOffers);
  }, [filters, loanOffers]);

  const updateTableSort = (sortField?: keyof OfferDto) => {
    if (!sortField) {
      return;
    }

    const isSortDesc = filters.sortField === sortField ? !filters.isSortDesc : true;

    setFilters({ sortField: sortField, isSortDesc: isSortDesc });
  };

  return isMobile ? (
    <OffersTableMobile
      offers={sortedLoanOffers}
      onAcceptOffer={onAcceptOffer}
      isDisabled={isDisabled}
      filters={filters}
      updateTableSort={updateTableSort}
    />
  ) : (
    <OffersTable
      offers={sortedLoanOffers}
      onAcceptOffer={onAcceptOffer}
      isDisabled={isDisabled}
      filters={filters}
      updateTableSort={updateTableSort}
    />
  );
};

export default OffersTableWrapper;
